// import { v4 as uuidv4 } from 'uuid';
import { jsonKeyToString } from '../../../helpers/jsonToString';
import MainInput from './MainInput';
import { mainDataValue } from '../../../helpers/mainDataConvert';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import ColumnsLayout from '../../ui/ColumnsLayout';
import { ImageType, MainData as MainDataType } from '../../../interfaces/intakes.reports';
import MainDates from './MainDates';
import { datesInputs, MainDataAllowed } from '../../../data/mainData';
import { MainDataImages } from './MainDataImages';

interface Props {
    reportId?: string
    mainData: Record<string, any> | null
    mainDataImages?: ImageType[]
    setMainData?: Dispatch<SetStateAction<MainDataType>>
    isList?: boolean
    className?: string
    allDisabled?: boolean
}

export const MainData = ({ reportId, mainData, setMainData, isList = false, className, allDisabled = false, mainDataImages }: Props) => {
    
    const hiddenProperties: (keyof MainDataAllowed)[] = [ "order_line" ]
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (setMainData) {
            setMainData((prev: Record<string, any>) => {
                return { ...prev, [e.target.name]: e.target.value }
            })
        }
    };

    const handleDate = (name: string, date: Date) => {
        if (setMainData) {
            setMainData((prev: Record<string, any>) => {
                return { ...prev, [name]: date }
            })
        }
    };

    return (
        <div className={className}>
            {
                mainData &&
                <ColumnsLayout columns={isList ? 2 : 1}>
                    {
                        Object.entries(mainData).map(item => (
                            isList
                                ?
                                <div key={item[0]} className={`main-info__item mb-05 ${hiddenProperties.includes(item[0] as keyof MainDataAllowed) ? "tw-hidden" : ""}`}>
                                    <p>{jsonKeyToString(item[0])}</p>
                                    <p className="bold">{mainDataValue(item[0], item[1])}</p>
                                </div>
                                :

                                <div key={item[0]} className={`grid intake__input ${hiddenProperties.includes(item[0] as keyof MainDataAllowed) ? "tw-hidden" : ""}`}>
                                    <label className="span-5 ">{jsonKeyToString(item[0])}</label>

                                    {
                                        !datesInputs.includes(item[0])
                                            ?
                                            <MainInput
                                                item={item}
                                                handleChange={handleChange}
                                                disabled={allDisabled}
                                            />
                                            :
                                            <MainDates
                                                item={item}
                                                handleDate={handleDate}
                                                disabled={allDisabled}
                                            />
                                    }
                                </div>
                        ))
                    }
                </ColumnsLayout>
            }
            {
                (mainDataImages && reportId) &&
                <MainDataImages images={mainDataImages || []} reportId={reportId}/>
            }
        </div>

    )
}